module.exports = __webpack_public_path__ + "img/job-detail-show-null.8b451bd3.jpg";